export function removeBackslashes(str) {
  if (!str) {
    return str;
  }

  let result = '';

  for (const character in str) {
    if (str.charCodeAt(character) === 8) {
      result = result.slice(0, -1);
    } else {
      result += str.charAt(character);
    }
  }

  return result;
}
